import isString from 'lodash/isString';
import moment from 'moment';
import { ALL_SOURCES, TIME_FILTERS } from './hooks';

const map: Record<number, string> = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  422: 'Unprocessable Entity',
  429: 'Too Many Requests',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
};

export const getErrorMessage = (statusCode: number) => map[statusCode] || statusCode;

export const getFilterParams = (sourceFilter: string, timeFilter: string) => ({
  sourceId: sourceFilter === ALL_SOURCES.value ? undefined : sourceFilter,
  ...getTimeParams(timeFilter),
});

export const getTimeParams = (timeFilter: string) => {
  let start = '';
  let aggregationMinutes = 100;
  if (timeFilter === TIME_FILTERS[0].value) {
    start = moment.utc().subtract(1, 'days').toISOString();
    aggregationMinutes = 10;
  }
  if (timeFilter === TIME_FILTERS[1]?.value) {
    start = moment.utc().subtract(7, 'days').toISOString();
    aggregationMinutes = 60;
  }
  if (timeFilter === TIME_FILTERS[2]?.value) {
    start = moment.utc().subtract(30, 'days').toISOString();
    aggregationMinutes = 60 * 24;
  }
  return {
    start,
    aggregationMinutes,
  };
};

export const formatGraphLabel = (timeFilter: string) => {
  if (timeFilter === TIME_FILTERS[0].value) {
    return 'HH:mm';
  }
  if (timeFilter === TIME_FILTERS[1]?.value) {
    return 'MMM D, HH:mm';
  }
  return 'MMM D';
};

export const truncate = (event: unknown) => {
  const str = isString(event) ? event : JSON.stringify(event);
  if (str.length > 30) {
    return `${str.substring(0, 30)}...`;
  }
  return str;
};

export const getYStepSize = (delivered: (number | null)[], failed: (number | null)[]) =>
  Math.max(getStepSize(delivered), getStepSize(failed));

const getStepSize = (input: (number | null)[]) => {
  if (!input || input.length === 0) {
    return 0;
  }
  const max = Math.max(...input.filter((x): x is number => !!x));
  if (max <= 0) {
    return 0;
  }
  const nearest10th = 10 ** String(max).length;
  const stepsCount = 5;
  const size = nearest10th / stepsCount;
  if (nearest10th / 2 > max) {
    return size / 2;
  }
  return size;
};
